const InvestmentsChallenge2InitialText ="Match the statements in the 'Investment Characterization' " +
    "column to the type of investment by dragging the statement to the correct column. " + 
    "When you are done, click the 'Done' button."

export default InvestmentsChallenge2InitialText 
